<template lang="pug">
div
  UiStack(vertical)
    RestTable(
      ref="table"
      namespace="files"
      :headers="headers"
      :fetch-handler="getData"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem
            UiStack
              UiStackItem
                label(label-for="search") {{ $t("labels.search") }}
              UiStackItem
                UiInput.filter-input(
                  :modelValue="filters.search"
                  @update:modelValue="updateFilters({ search: $event || undefined })"
                  :placeholder="$t('placeholders.type')"
                )
          UiStackItem
            UiStack
              UiStackItem
                label(label-for="status") {{ $t("labels.status") }}
              UiStackItem
                UiSelect.filter-input(
                  :searchable="false"
                  :options="statusOptions"
                  :modelValue="filters.status"
                  @update:modelValue="updateFilters({ status: $event || undefined })"
                )
          UiStackItem(fill)
          UiStackItem
            UiButton(
              variant="primary"
              @click="callRestartDialog"
              icon="RefreshCw"
            ) {{ $t("actions.restart_all_failed") }}
      template(#cell:status="{ item }")
        FileStatusBadge(:status="item.status")
      template(#cell:invoices_count="{ item }")
        RouterLink(:to="getInvoicesLink(item)") {{ item.invoices_count }}
      template(#cell:customers_count="{ item }")
        RouterLink(:to="getCustomerLink(item)") {{ item.customers_count }}
</template>

<script>
import ApiDigiaFiles from "@/api/digia_files.js";
import FileStatusBadge from "./components/file_status_badge.vue";
import ApiDigiaCustomers from "@/api/digia_customers.js";
import isEqual from "lodash/isEqual";

export default {
  components: {
    FileStatusBadge,
  },

  props: {
    globalRequestFilters: {
      type: Object,
      required: true,
    },
  },

  computed: {
    headers() {
      return [
        {
          key: "id",
          label: this.$t("labels.file_id"),
          sortable: true,
        },
        {
          key: "filename",
          label: this.$t("labels.file_name"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("labels.date"),
          sortable: true,
        },
        {
          key: "invoices_count",
          label: this.$t("labels.invoices_count"),
          sortable: true,
        },
        {
          key: "customers_count",
          label: this.$t("labels.customers_count"),
          sortable: true,
        },
        {
          key: "status",
          label: this.$t("labels.status"),
          sortable: true,
        },
        {
          key: "status_reason",
          label: this.$t("labels.status_reason"),
          width: "35%",
        },
      ];
    },

    statusOptions() {
      return [
        {
          value: null,
          label: this.$t("labels.any_status"),
        },
        {
          value: "failed",
          label: this.$t("labels.failed"),
        },
        {
          value: "processed",
          label: this.$t("labels.processed"),
        },
        {
          value: "processing",
          label: this.$t("labels.processing"),
        },
      ];
    },
  },

  watch: {
    globalRequestFilters: {
      handler(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) return;
        this.refetchTable();
      },
      deep: true,
    },
  },

  methods: {
    refetchTable() {
      this.$refs.table.fetchData();
    },

    getInvoicesLink(item) {
      return {
        ...this.$route,
        query: {
          ...this.$route.query,
          digia_tab: "invoices",
          files: JSON.stringify([{ value: item.id, label: item.filename }]),
        },
      };
    },

    getCustomerLink(item) {
      return {
        ...this.$route,
        query: {
          ...this.$route.query,
          digia_tab: "customers",
          files: JSON.stringify([{ value: item.id, label: item.filename }]),
        },
      };
    },

    getData(params, config) {
      return ApiDigiaFiles.fetchAll(
        { ...this.globalRequestFilters, ...params },
        config,
      ).then((response) => {
        return {
          items: response.data.digia_files,
          meta: response.data.meta,
        };
      });
    },

    callRestartDialog() {
      this.$dialogConfirm({
        title: "Restart all failed",
        description: "Do you really want to restart all failed invoices?",
        variant: "danger",
        okLabel: this.$t("actions.restart_all_failed"),
      }).then((result) => {
        if (!result) return;
        ApiDigiaCustomers.restart({
          ...this.globalRequestFilters,
        }).then(() => {
          this.refetchTable();
        });
      });
    },
  },
};
</script>

<style lang="css" scoped>
.input {
  min-width: 240px;
}
</style>
